import { SxProps, Theme } from '@mui/material';

export const mergeSx = (...styles: Array<SxProps<Theme> | false | '' | null | undefined>): SxProps<Theme> => {
  const filteredStyles = styles.filter(Boolean) as SxProps<Theme>[];

  if (filteredStyles.length === 0) {
    return {};
  }

  if (filteredStyles.length === 1) {
    return filteredStyles[0];
  }

  return filteredStyles.flatMap((style) => (Array.isArray(style) ? style : [style]));
};
